<template>
  <div v-click-outside="close" class="dropdown-menu" :class="cssClass">
    <button
      :class="{ _opened: opened }"
      class="dropdown-menu__button"
      type="button"
      @click="opened = !opened"
    >
      <slot name="dropdown-menu__button" />
    </button>
    <div v-if="opened" :class="position" class="dropdown-menu__list">
      <slot name="dropdown-menu__list" />
    </div>
  </div>
</template>
<script>
export default {
  props: {
    position: {
      type: String,
      default: 'bottom-right'
    },
    cssClass: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      opened: false
    };
  },
  methods: {
    close() {
      this.opened = false;
    }
  }
};
</script>
<style src="./dropdown-menu.css" />
